import { Box } from "@mui/material"
import { FacilitatorNavMenu } from "./FacilitatorNavMenu"
import { TopNav } from "../common/top-nav/top-nav"

export const Facilitator = (element: any): JSX.Element => {
  return (
    <>

      <TopNav></TopNav>

      <Box
        component="main"
        sx={{
          bgcolor: "#f5f5f5",
          flexGrow: 1,
          height: "100vh",
          overflow: "hidden",
        }}
      >

        <Box sx={{ display: 'flex', height: '100%', paddingTop: '80px' }}>

          <FacilitatorNavMenu />
          <Box className="content-container" sx={{ flexGrow: 1, minWidth: 0, pt: 3.5, pb: 4, px: 4, height: '100%', overflow: 'auto' }}>
            {element.children}
          </Box>

        </Box>

      </Box>

    </>
  )
}